import { axios } from "./http.js";

export const addFriend = params => {
  return axios.post("/friend/", params);
};
export const getFriendList = params => axios.get("/friend/list", params);

export const deleteFriend = id => {
  return axios.delete(`/friend/${id}`);
};

export const putFriend = params => {
  return axios.put(`/friend/${params.id}`, params);
};
export const getFriend = id => axios.get(`/friend/${id}`);
